module.exports = __webpack_public_path__ + "static/img/trauerreden-800x480.1dd026e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ueber-mich/trauerreden-800x480.jpg
// module id = BTIc
// module chunks = 0